import { QFilterGeneric } from './QFilterGeneric'

export class QFilterCustom extends QFilterGeneric {
  name=""
  class_name = "QFilterCustom"
  api_name = "custom_filter";
    
  constructor(value, name=null, api_name=null) {
    super(value);
    if (name) {
      this.name = name;
      this.api_name = name;
    }
    if (api_name) {
      this.api_name = api_name;
    }
  }
}
